/* ============================================
   ELIASE BEAUTY — PREMIUM WHATSAPP WIDGET JS
   Luxury floating chat experience
   ============================================ */

(function() {
  'use strict';

  // ═══════════════════════════════════════════
  // CONFIGURATION
  // ═══════════════════════════════════════════
  
  const CONFIG = {
    // WhatsApp number (international format, no + or spaces)
    phoneNumber: '254706492887',
    
    // Pre-filled message
    defaultMessage: 'Hi! I\'m interested in your premium skincare products ✨',
    
    // Business info
    businessName: 'Eliase Beauty',
    greetingMessage: 'Hey there, thank you for contacting Eliase Beauty. How can we help you achieve a healthy skincare routine today?',
    tooltipText: 'Chat with us',
    
    // Popup behavior
    autoPopupDelay: 8000, // 8 seconds, set to 0 to disable
    showPopupOnce: true,
    
    // Position
    position: 'right',
    
    // Hide on these pages
    hideOnPages: ['/checkout', '/cart'],
    
    // Avatar emoji
    avatarLogo: 'https://eliasebeauty.com/cdn/shop/files/eliase-logo.png?v=1783068271&width=100'
  };

  // ═══════════════════════════════════════════
  // CHECK IF SHOULD RUN
  // ═══════════════════════════════════════════

  const currentPath = window.location.pathname;
  if (CONFIG.hideOnPages.some(path => currentPath.startsWith(path))) {
    return;
  }

  // ═══════════════════════════════════════════
  // CREATE WIDGET
  // ═══════════════════════════════════════════

  function createWidget() {
    const widget = document.createElement('div');
    widget.className = 'eliase-whatsapp-widget';
    
    if (CONFIG.position === 'left') {
      widget.style.right = 'auto';
      widget.style.left = '28px';
    }

    widget.innerHTML = `
      <!-- Main Button -->
      <button class="eliase-wa-button" aria-label="Chat on WhatsApp" id="eliase-wa-btn">
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
        </svg>
      </button>
      
      <!-- Tooltip -->
      <div class="eliase-wa-tooltip">${CONFIG.tooltipText}</div>
      
      <!-- Premium Chat Popup -->
      <div class="eliase-wa-popup" id="eliase-wa-popup">
        <button class="eliase-wa-popup__close" aria-label="Close" id="eliase-wa-close">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L11 11M1 11L11 1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
        </button>
        
        <div class="eliase-wa-popup__header">
          <div class="eliase-wa-popup__avatar"><img src="${CONFIG.avatarLogo}" alt="Eliase Beauty" /></div>
          <div class="eliase-wa-popup__info">
            <h4>${CONFIG.businessName}</h4>
            <div class="eliase-wa-popup__status">Online now</div>
          </div>
        </div>
        
        <div class="eliase-wa-popup__body">
          <div class="eliase-wa-popup__message">
            ${CONFIG.greetingMessage}
            <span class="eliase-wa-popup__time">${getCurrentTime()}</span>
          </div>
        </div>
        
        <div class="eliase-wa-popup__footer">
          <a href="${getWhatsAppLink()}" target="_blank" rel="noopener noreferrer" class="eliase-wa-popup__cta">
            <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
            </svg>
            <span>Start Conversation</span>
          </a>
        </div>
      </div>
    `;

    document.body.appendChild(widget);
    initEvents();
    
    if (CONFIG.autoPopupDelay > 0) {
      handleAutoPopup();
    }
  }

  // ═══════════════════════════════════════════
  // HELPERS
  // ═══════════════════════════════════════════

  function getWhatsAppLink() {
    const message = encodeURIComponent(CONFIG.defaultMessage);
    return `https://wa.me/${CONFIG.phoneNumber}?text=${message}`;
  }

  function getCurrentTime() {
    const now = new Date();
    return now.toLocaleTimeString('en-US', { 
      hour: 'numeric', 
      minute: '2-digit',
      hour12: true 
    });
  }

  function initEvents() {
    const btn = document.getElementById('eliase-wa-btn');
    const popup = document.getElementById('eliase-wa-popup');
    const closeBtn = document.getElementById('eliase-wa-close');

    // Toggle popup
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      
      if (!popup.classList.contains('is-open')) {
        popup.classList.add('is-open');
        sessionStorage.setItem('eliase-wa-popup-shown', 'true');
      } else {
        window.open(getWhatsAppLink(), '_blank', 'noopener,noreferrer');
      }
    });

    // Close popup
    closeBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      popup.classList.remove('is-open');
    });

    // Close on escape
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && popup.classList.contains('is-open')) {
        popup.classList.remove('is-open');
      }
    });

    // Close on outside click
    document.addEventListener('click', function(e) {
      const widget = document.querySelector('.eliase-whatsapp-widget');
      if (popup.classList.contains('is-open') && !widget.contains(e.target)) {
        popup.classList.remove('is-open');
      }
    });
  }

  function handleAutoPopup() {
    if (CONFIG.showPopupOnce && sessionStorage.getItem('eliase-wa-popup-shown')) {
      return;
    }

    setTimeout(function() {
      const popup = document.getElementById('eliase-wa-popup');
      if (popup && !popup.classList.contains('is-open')) {
        popup.classList.add('is-open');
        sessionStorage.setItem('eliase-wa-popup-shown', 'true');
      }
    }, CONFIG.autoPopupDelay);
  }

  // ═══════════════════════════════════════════
  // INIT
  // ═══════════════════════════════════════════

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', createWidget);
  } else {
    createWidget();
  }

})();